/**
 * Converte a marcação do Channel → HTML.
 * Suporta negrito, itálico, tachado, variáveis {{…}} e agora `code inline`.
 */
export function parseChannelMarkupToHtml(text: string): string {
  let html = text;

  // 1) Escapa primeiro para não quebrar a árvore HTML
  html = html
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  /* 2) Code inline precisa vir ANTES dos outros estilos
        para que crases dentro de *bold* etc. não sejam processadas duas vezes.
        [^`\n] evita pegar múltiplas linhas. */
  html = html.replace(
    /`([\s\S]+?)`/g,
    `<code style="background:#38BDF821;padding:2px 4px;border-radius:4px;font-family:monospace;white-space:pre-wrap;">$1</code>`
  );

  // 3) Demais marcações
  html = html.replace(/\*(.+?)\*/g, "<strong>$1</strong>");
  html = html.replace(/_(.+?)_/g, "<em>$1</em>");
  html = html.replace(/~(.+?)~/g, "<s>$1</s>");
  html = html.replace(
    /\{\{(.+?)\}\}/g,
    `<span data-type="variable" style="background-color:#38BDF8;padding:2px 4px;border-radius:4px;font-size:12px;color:#101828;">$1</span>`
  );

  // 4) Quebras de linha
  html = html.replace(/\n/g, "<br />");

  return html;
}

/**
 * Converte HTML (produzido pela função acima) → marcação Channel.
 */
export function parseHtmlToChannelMarkup(html: string): string {
  let text = html;

  // Variáveis {{…}}
  text = text.replace(
    /<span[^>]*data-type="variable"[^>]*>(.*?)<\/span>/g,
    "{{$1}}"
  );

  // Code inline (processar antes de remover tags genéricas)
  text = text.replace(/<code[^>]*>([\s\S]*?)<\/code>/g, "`$1`");

  // Negrito, itálico, tachado
  text = text.replace(/<strong>(.*?)<\/strong>/g, "*$1*");
  text = text.replace(/<em>(.*?)<\/em>/g, "_$1_");
  text = text.replace(/<s>(.*?)<\/s>/g, "~$1~");

  // <br> → \n
  text = text.replace(/<br\s*\/?>/g, "\n");

  // Remove qualquer outra tag que porventura tenha sobrado
  text = text.replace(/<\/?[^>]+(>|$)/g, "");

  return text;
}

/**
 * Remove TODAS as marcações, preservando o texto “limpo”.
 */
export function removeFormattingMarksPreservingSpacing(text: string): string {
  // Negrito, itálico, tachado, code
  text = text.replace(/\*(.+?)\*/g, "$1");
  text = text.replace(/_(.+?)_/g, "$1");
  text = text.replace(/~(.+?)~/g, "$1");
  text = text.replace(/`(.+?)`/g, "$1");

  return text;
}
